import * as React from 'react';
import { useState, useEffect } from 'react';
import { ImportStudents } from './ImportStudents';
import { AppUser } from 'Src/views/App/App';
import { Loader } from 'Src/components/Loader/Loader';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getAllHouses } from 'Src/helpers/service/admin/houses';

interface ImportStudentsWrapperProps {
  user: AppUser;
}

export const ImportStudentsWrapper: React.FC<ImportStudentsWrapperProps> = ({ user }) => {
  const [school, setSchool] = useState<any>(null);
  const [forms, setForms] = useState<any[]>([]);
  const [houses, setHouses] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isAdmin = user && user.activeRole === 'ADMIN';

  useEffect(() => {
    const fetchSchoolData = async () => {
      if (!isAdmin) {
        setIsLoading(false);
        return;
      }
      if (user && user.activeSchool) {
        setSchool(user.activeSchool);
        try {
          const fetchedForms = await getAllForms(user);
          setForms(fetchedForms);
          const fetchedHouses = await getAllHouses(user);
          setHouses(fetchedHouses);
        } catch (error) {
          console.error('Error fetching forms or houses:', error);
        }
      } else {
        console.error('Active school data is missing or incomplete.');
      }
      setIsLoading(false);
    };

    fetchSchoolData().catch(error => {
      console.error('Unhandled error in useEffect:', error);
    });

    return () => {};
  }, [isAdmin, user]);

  if (isLoading) {
    return <Loader />;
  }
  if (!isAdmin) {
    return (
      <div className="imp">
        <div className="imp__disabled">
          <div>
            <h2>Administrator access required</h2>
            <p>Only a school administrator can import or replace the student register.</p>
          </div>
        </div>
      </div>
    );
  }
  return <ImportStudents user={user} school={school} forms={forms} houses={houses} />;
};
